const style = ` 
  :root {
    --main-color: #29b355
  }
  #cashier h5 {
    color: #5a5a5a!important;
  }
  #cashier label {
    font-size: 16px!important;
    color: #1e1e1e;
    display: block;
    margin-bottom: 4px;
    font-weight: 500;
  }
  #cashier .dropdown-toggler {
    border: 1px solid;
    padding: 10px;
  }
  #cashier input {
    padding: 10px;
    padding-left: 10px!important;
    border: 1px solid #5a5a5a!important;
    border-radius: 4px!important;
    height: 52px;
    background: #fafafa!important;
  }
  #cashier .list-payment-methods {
    padding: 10px 0!important;
  }
  #cashier .main-header-container h3 {
    font-size: 18px!important;
    font-weight: 600;
    text-transform: lowercase!important;        
  }
  #cashier .payment-method-label:first-letter {
    text-transform: uppercase!important;
  }
  @media (min-width: 767px) {
    .payment-method-details {
      padding: 10px 50px!important;
    }
  }      
  #cashier .list-payment-methods .payment-method:hover {
    box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
  }
  #cashier .list-payment-methods .payment-method {
    transition: all .2s cubic-bezier(.25,.8,.25,1)!important;
    box-shadow: none;
    overflow: hidden;
    margin-bottom: 8px;        
    border-radius: 7px;
    border: 1px solid #cfcfcf!important;
  }
  #cashier .payment-method.active {
    border-color: #a3a3a3!important;
  }
  #cashier .payment-method .payment-method-header {
    padding: 10px 15px!important;
    border-radius: 7px;
    background-color: #fff;
    border: none!important;
  }
  #cashier .submit-button {
    border-radius: 100px!important;        
  }
  #cashier button:not(.predefinedvalue):disabled {
    background: #a3a3a3!important;
    opacity: 1;        
  }

  #cashier .list-payment-methods {
    padding: 10px 10px !important;
  }
`
export default style
